import PropTypes from "prop-types";

const propTypes = {
  adresa: PropTypes.shape({
    ULICA: PropTypes.string,
    CS: PropTypes.number,
    CO: PropTypes.string,
    PSC: PropTypes.string,
    OBEC: PropTypes.string,
    ADRESA_MERGED: PropTypes.string,
  }),
};

export default propTypes;
